import { css } from "@emotion/react"

export const resetStyleButton = css`
    position: relative;
    box-sizing: border-box;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0px;
    margin: 0px;
    color: inherit;
    text-align: center;
    text-decoration: none;
    white-space: nowrap;
    cursor: pointer;
    background-color: transparent;
    border: none;
    appearance: none;
    &:disabled {
        cursor: not-allowed;
    }
    &:focus:not(:focus-visible) {
        outline: none;
    }
`
